<style lang="scss">

    #popup-container{
        position:fixed;
        top:0;
        left:0;
        width:100vw;
        height:100%;
        z-index:99999;
        pointer-events: none;
        overflow: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 0px;
        padding-bottom: 30px;
        overflow-y: scroll;

        @media (max-height: 700px) {
            align-items: start;
        }

        &.appear{
            pointer-events: all;
            transition: all 600ms;

            .background-obfuscator{
                opacity:1;
                transition: all 600ms;
            }

            .delete-address-popup{
                margin-top:70px;

                @media (max-width: 575px) {
                    margin-top:20px;
                }

                margin-bottom:20px;
                opacity: 1;
                transition: all 600ms;
                transition-delay: 400ms;
            }

        }

        .delete-address-popup{
            position: absolute;
            margin-top:20px;
            width: 90%;
            height:auto;
            display: flex;
            max-width: 400px;
            background: #f1ece5;
            padding:20px;
            opacity:0;

            @media(min-width: 992px) {
                padding:30px 25px;
            }

        }

        .background-obfuscator{
            position:fixed;
            left:0px;
            top:0;
            width: calc(100%);
            height:100%;
            background:rgba(0, 0, 0, 0.7);
            z-index:-1;
            opacity: 0;
            transition: all 600ms;
        }

    }

</style>

<template>
    <div id="popup-container" :class="{'appear' : show}">
        <div class="background-obfuscator" @click="closePopup"></div>

        <div class="delete-address-popup">
            <!--<div class="close-preview" @click="closePopup">
                <img width="10" src="/img/frontend/x-01.svg" alt="chiudi"/>
            </div>-->
            <div class="col-12">
                <div class="row">
                    <div class="col-12 mb-2">
                        <div class="all-list">
                            <h4 class="azienda-gold-title azienda-gold-title--auth mb-2 text-center">
                                {{$root.translateString('delete-address')}}
                            </h4>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <p class="text-smaller-85 mt-4 mb-0 d-inline-flex">
                            <small>
                                <span class="brand-btn ml-0">
                                    <a href="javascript:void(0)" class="logout" @click="closePopup">
                                        <span>{{$root.translateString('cancel')}}</span>
                                    </a>
                                </span>
                            </small>
                        </p>
                    </div>
                    <div class="col-6">
                        <div class="brand-btn mt-0 mt-md-3">
                            <a href="javascript:void(0)" @click="deleteAddress" class="full py-1 text-center">
                            <span class="my-1">
                                 {{$root.translateString('remove')}}
                            </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <transition name="fade">
            <div class="loader-checkout d-flex align-items-center justify-content-center" v-if="loading">
                <img width="40" src="/images/loader.svg" alt="loader"/>
            </div>
        </transition>

    </div>
</template>
<script>

export default {
    props: ['lang'],
    data() {
        return {
            address_id: null,
            show: false,
            loading: false,
        }
    },
    mounted() {

        this.$eventHub.$on('show-delete-address-modal', (payload) => {
            this.address_id = payload;
            this.openPopup();
        });
    },
    methods: {
        deleteAddress() {
            axios.post('/api/user/remove-address', {
                id: this.address_id
            }).then((response) => {
                window.location.reload();
            }).catch( e =>  {
                let errors = e.response.data.errors;
                this.loading = false;

                // handle errors
                for (let error in errors) {
                    this.validation[error].message = errors[error][0];
                    this.validation[error].state = false;
                }
            });
        },
        openPopup() {
            this.show = true;
            document.body.style.top = `-${window.scrollY}px`;
            //document.body.style.position = 'fixed';
            $('body').toggleClass('menu-open');
        },
        closePopup() {
            this.show = false;
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
            $('body').toggleClass('menu-open');
        },
    },
    beforeDestroy() {
        this.$eventHub.$off('show-delete-address-modal');
    },
    computed: {
    }
}
</script>
